import { render, staticRenderFns } from "./BaiduAifanfan.vue?vue&type=template&id=6b7cd58e&scoped=true"
import script from "./BaiduAifanfan.vue?vue&type=script&lang=js"
export * from "./BaiduAifanfan.vue?vue&type=script&lang=js"
import style0 from "./BaiduAifanfan.vue?vue&type=style&index=0&id=6b7cd58e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7cd58e",
  null
  
)

export default component.exports